// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbooksForOrganizationQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type WorkbooksForOrganizationQuery = {
  __typename?: "GraphqlQuery";
  getWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    variantsCount: number;
    draft: boolean;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database: { __typename?: "Database"; id: string; datname?: string | null };
  }>;
};

export const WorkbooksForOrganizationDocument = gql`
  query WorkbooksForOrganization($organizationSlug: ID!) {
    getWorkbooks(organizationSlug: $organizationSlug) {
      id
      name
      description
      createdAt
      lastActivityAt
      variantsCount
      draft
      user {
        id
        fullname
      }
      server {
        id
        humanId
        name
      }
      database {
        id
        datname
      }
    }
  }
`;

/**
 * __useWorkbooksForOrganizationQuery__
 *
 * To run a query within a React component, call `useWorkbooksForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksForOrganizationQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useWorkbooksForOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  > &
    (
      | { variables: WorkbooksForOrganizationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  >(WorkbooksForOrganizationDocument, options);
}
export function useWorkbooksForOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  >(WorkbooksForOrganizationDocument, options);
}
// @ts-ignore
export function useWorkbooksForOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForOrganizationQuery,
  WorkbooksForOrganizationQueryVariables
>;
export function useWorkbooksForOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForOrganizationQuery,
        WorkbooksForOrganizationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForOrganizationQuery | undefined,
  WorkbooksForOrganizationQueryVariables
>;
export function useWorkbooksForOrganizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForOrganizationQuery,
        WorkbooksForOrganizationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbooksForOrganizationQuery,
    WorkbooksForOrganizationQueryVariables
  >(WorkbooksForOrganizationDocument, options);
}
export type WorkbooksForOrganizationQueryHookResult = ReturnType<
  typeof useWorkbooksForOrganizationQuery
>;
export type WorkbooksForOrganizationLazyQueryHookResult = ReturnType<
  typeof useWorkbooksForOrganizationLazyQuery
>;
export type WorkbooksForOrganizationSuspenseQueryHookResult = ReturnType<
  typeof useWorkbooksForOrganizationSuspenseQuery
>;
export type WorkbooksForOrganizationQueryResult = Apollo.QueryResult<
  WorkbooksForOrganizationQuery,
  WorkbooksForOrganizationQueryVariables
>;
